export enum eOfferAcceptDecline
{
    Accept = '1',
    Decline = '2'
}